module.exports = __webpack_public_path__ + "static/media/cheerful-happy.cccd028f.png";